import { THEME_NAMES } from "./config";

export const BBVATheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.BBVATheme,
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/BBVA_2019.svg/1280px-BBVA_2019.svg.png",
  palette: {
    primary: {
      main: "#1973b8",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#028484",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#072146",
      contrastText: "#fff",
      // main: "#1A1A1A",
      // contrastText: "#eeeeee",
      accent: "#49a5e6",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#121212",
      primary: "#121212",
      secondary: "#77787b",
    },
    status: {
      active: "#2dcd8a",
      approved: "#2ecccc",
      analysing: "#1973b8",
      sent: "#08404d",
      cancelled: "#d8d8d8",
      denied: "#ef5957",
    },
    info: {
      main: "#1973b8",
      contrastText: "#fff",
      light: "#eaf9fa",
    },
    warning: {
      main: "#f8cd51",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    success: {
      main: "#2dcccd",
      contrastText: "#ffffff",
      light: "#eaf9fa",
    },
  },
  background: "#f4f4f4",
  customBorderRadius: {
    button: 2,
    paper: 0,
  },
  shadows: [
    "none",
    "none",
    "none", // 2 buttons
    "none", // 3 papers soft
  ],
  typography: {
    fontFamily: "Helvetica, Arial, sans-serif",
  },
};
